import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Container, Paper, Typography } from '@mui/material';
import Footer from '../components/common/Footer';

const AuthLayout = () => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        minHeight: '100vh',
        backgroundColor: 'background.default',
        backgroundImage: 'linear-gradient(rgba(10, 25, 41, 0.8), rgba(10, 25, 41, 0.9)), url("/images/earth-bg.jpg")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <Container 
        component="main" 
        maxWidth="lg" 
        sx={{ 
          flex: 1, 
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent: 'center', 
          py: 4 
        }}
      >
        <Box 
          sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            // mb: 4 
          }}
        >
          <img src="/images/logo.svg" alt="HELP-Zero" height="120" />
        </Box>
        
        <Outlet />
      </Container>
      <Footer />
    </Box>
  );
};

export default AuthLayout;
